import styled from "styled-components";

import { media } from "../../../../../styles/media";

export const SpecialDaysStyles = styled.div`
  .addFormCard {
    display: inline-block;
    max-width: 100%;
    box-sizing: border-box;
    background: ${({ theme }) => theme.colors.accent[50]};
    border: 1px solid ${({ theme }) => theme.colors.accent[200]};
    border-radius: ${({ theme }) => theme.radius[12]};
    padding: ${({ theme }) => theme.spacing[16]};

    ${media.maxMobile`
      display: block;
    `}
  }

  .formContainer {
    display: flex;
    align-items: center;
    gap: ${({ theme }) => theme.spacing[16]};

    .inputsContainer {
      display: flex;
      gap: ${({ theme }) => theme.spacing[12]};
      flex: 1 1 auto;
      min-width: 0;

      .inputContainer {
        flex: 1 1 200px;
        min-width: 0;

        .input {
          margin-top: 2px;
        }
      }
    }

    .button {
      min-width: 113px;
      align-self: center;
    }

    ${media.maxMobile`
      flex-direction: column;
      align-items: stretch;
      gap: 12px;

      .inputsContainer {
        flex-direction: column;
        width: 100%;
        gap: 8px;

        .inputContainer {
          flex: 0 0 auto;
          width: 100%;
        }
      }

      /* Every field reserves a fixed 24px error slot below it; stacked on a
         phone all that empty space adds up. Collapse it so fields sit tight —
         the slot still expands when a validation error actually appears. */
      .errorMessage {
        height: auto;
      }

      .button {
        width: 100%;
      }
    `}
  }

  .listLabel {
    margin-top: ${({ theme }) => theme.spacing[24]};
    margin-bottom: ${({ theme }) => theme.spacing[16]};
    font-weight: ${({ theme }) => theme.typography.title.t2.weight};
    font-size: ${({ theme }) => theme.typography.body.b2.size};
    color: ${({ theme }) => theme.colors.semantic.text.weak};
  }

  .specialDaysList {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: ${({ theme }) => theme.spacing[16]};
    ${media.maxTablet`grid-template-columns: repeat(2, 1fr);`}
    ${media.maxMobile`grid-template-columns: 1fr;`}
  }
`;
